import { createSlice } from '@reduxjs/toolkit'
import { openSnackBar } from './snackBarReducer'
import {artService} from '../services/artwork.service'

export const artworkSlice = createSlice({
    name: 'artwork',
    initialState: {
        artworks: [],
        artworkCnt: 0,
        currentPage: 1,
    },
    reducers: {
        setArtworks: (state, action) => {
            state.artworks = action.payload;
        },
        setArtworkCnt: (state, action) => {
            state.artworkCnt = action.payload;
        },
        setCurrentPage:(state, action) => {
            console.log("currentPage:", action.payload);
            state.currentPage = action.payload;
        }
    }
})

export const {setArtworks, setArtworkCnt, setCurrentPage} = artworkSlice.actions;

/** API returns { id, artwork, artist }; cards expect flat artwork + userDetails[]. */
export function normalizeArtworkItem(item) {
    if (!item) return null;
    if (item.name != null && item.images != null) {
        return {
            ...item,
            userDetails: item.userDetails || (item.artist ? [item.artist] : []),
        };
    }
    const artwork = item.artwork || item;
    const artist = item.artist || null;
    return {
        ...artwork,
        _id: item.id || artwork._id,
        userDetails: artist ? [artist] : [],
    };
}

export const getArtworks = (type, filterkey='', order=false, pagesize=10, pagefrom=0) => async (dispatch) => {
    try {
        const respData = await artService.getArtworks(type, filterkey, order, pagesize, pagefrom);
        if ( respData.status === 'success' ) {
            const normalized = (respData.artworks || [])
                .map(normalizeArtworkItem)
                .filter(Boolean);
            dispatch(setArtworks(normalized));
        }
    }  catch (error) {
        if (error.status !== 401) {
            dispatch(openSnackBar({ message: error.message, status: 'error' }));
        }
    }
}

export const getArtworkCnt = () => async (dispatch) => {
    try {
        const respData = await artService.getArtworkCnt();
        if ( respData.status === 'success' ) {
            dispatch(setArtworkCnt(respData.artworkCnt));
        }
    }  catch (error) {
        if (error.status !== 401) {
            dispatch(openSnackBar({ message: error.message, status: 'error' }));
        }
    }
}


export const selectArtworks = (state) => state.artworkState.artworks;
export const selectArtworkCnt = (state) => state.artworkState.artworkCnt;
export const selectCurrentPage = (state) => state.artworkState.currentPage;

export default artworkSlice.reducer;